export const LEFT_PANEL_WIDTH = 436;
